export class FunctionResultMessageData {
  public functionCall: any;

  constructor(data: any) {
    this.functionCall = data;
  }
}
